<template>
  <div class="doctorsListBox">
    <div class="top" style="padding-top: 0px;">
      <a class="arr" @click.prevent="backHome"
        ><div class="inner"></div>
        <span>返回</span></a
      >
      <div class="txt">
        請點選看診醫師<img src="@/assets/images/icon_filter.svg" />
      </div>
    </div>
    <div class="listing">
      <div class="doctors">
        <div class="inner" ref="inner">
          <div :class="cssAll" @click="selectAll()">
            <div class="pic"><img src="@/assets/images/doctor_bg.png" /></div>
            <p class="name">全部的醫師</p>
          </div>
          <div
            :class="cssDoctor(d)"
            style="cursor: pointer;"
            v-for="(d, idx) in filteredDoctors"
            :key="idx"
            @click="selectedDoctor = d"
          >
            <div class="pic">
              <img
                :src="
                  `https://assets.musoon.clinic/images/dr/300x300/${d.name}.jpg`
                "
              />
            </div>
            <p class="name">{{ d.name }}&nbsp;&nbsp;{{ d.title }}</p>
          </div>
        </div>
      </div>
      <a href="#" class="arr left" @click="scroll('left')">
        <div class="inner"></div>
      </a>
      <a href="#" class="arr right" @click="scroll('right')">
        <div class="inner"></div>
      </a>
    </div>
  </div>
  <debug v-if="debug">{{ selectedDoctor }}</debug>
</template>

<script>
export default {
  name: "AppointmentDoctors",
  props: ["filterDoctor"],
  emits: ["changeDoctor", "backAll", "backHome"],
  data() {
    return {
      debug: eval(process.env.VUE_APP_DEBUG),
      member: this.$store.state.member,
      doctors: [
        { name: "陳思宇", dept: "婦產科", title: "醫師" },
        { name: "呂佳澍", dept: "婦產科", title: "醫師" },
        { name: "李東衡", dept: "婦產科", title: "醫師" },
        { name: "李建南", dept: "婦產科", title: "醫師" },
        { name: "李汶芳", dept: "婦產科", title: "醫師" },
        { name: "張明揚", dept: "婦產科", title: "醫師" },
        { name: "李佳珩", dept: "婦產科", title: "醫師" },
        { name: "李木生", dept: "婦產科", title: "醫師" },
        { name: "彭圩心", dept: "小兒科", title: "醫師" },
        { name: "張學勤", dept: "小兒科", title: "醫師" },
        { name: "張馨宇", dept: "小兒科", title: "醫師" },
        { name: "邱彙雅", dept: "小兒科", title: "醫師" },
        { name: "林芷伃", dept: "營養科", title: "營養師" },
        { name: "蔡和蓉", dept: "助產諮詢科", title: "助產師" },
        // 12F
        { name: "蘇熙倫", dept: "皮膚科", title: "醫師" }
      ],
      selectedDoctor: null
    };
  },
  computed: {
    cssAll() {
      return this.selectedDoctor === null ? "box active" : "box";
    },
    filteredDoctors() {
      return this.doctors.filter(d => d.dept === this.filterDoctor.dept);
    }
  },
  watch: {
    selectedDoctor(val) {
      if (val && val.name) {
        this.$emit("changeDoctor", val);
        console.log(this.selectedDoctor);
      }
    }
  },
  methods: {
    backHome() {
      this.$emit("backHome");
    },
    scroll(direction) {
      // 每300一位醫師
      if (direction === "right") {
        this.$refs.inner.scrollLeft += 600;
      }
      if (direction === "left") {
        this.$refs.inner.scrollLeft -= 600;
      }
    },
    cssDoctor(d) {
      if (this.selectedDoctor === null) return "box";
      return d.name === this.selectedDoctor.name ? "box active" : "box";
    },
    selectAll() {
      this.$emit("backAll", this.selectedDoctor.dept);
      this.selectedDoctor = null;
    }
  }
};
</script>

<style scoped></style>
